/* ==========================================================================
   AI ADVISOR — Messenger pattern controller. Rebuilt in Phase 32.

   ############################################################################
   ##  THE ONLY THING THAT CHANGES WHEN THE REAL ENDPOINT LANDS               ##
   ##      FILE:      assets/advisor.js                                       ##
   ##      FUNCTION:  AdvisorTransport.send                                   ##
   ##  Unchanged from the first build. The block below was extracted from the  ##
   ##  previous file programmatically, not retyped, so it is byte-identical.   ##
   ############################################################################

   WHAT THE REBUILD CHANGED: the UI around the transport, from a single chat
   panel to a four-tab hub. What it did NOT change: this transport, the book-bar
   collision handling, Escape, focus return, aria-live and reduced motion.
   ========================================================================== */

(function () {
  'use strict';

  var CFG  = window.ADVISOR_CONFIG || {};
  var HELP = window.ADVISOR_HELP   || [];
  var SKEY = 'yu_advisor_conversation_id';

  /* ======================================================================
     TRANSPORT. Live endpoint since the advisor go-live; the mock path is
     RETIRED, NOT DELETED — set window.ADVISOR_USE_MOCK = true to get it
     back (offline demos, transport-free UI work). window.ADVISOR_MOCK
     ('error' | 'rate_limit' | 'budget') still forces those states in
     BOTH paths, which is the only way to test the notices without
     breaking something real.
     ====================================================================== */
  var ENDPOINT = 'https://meehyuwrizcgksqlanaf.supabase.co/functions/v1/advisor-chat';

  var AdvisorTransport = {

    send: function (opts) {
      if (window.ADVISOR_USE_MOCK) return AdvisorTransport._mockSend(opts);
      var forced = window.ADVISOR_MOCK;
      if (forced === 'error' || forced === 'rate_limit' || forced === 'budget') {
        setTimeout(function () { opts.onError({ kind: forced }); }, 300);
        return;
      }
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          conversationId: opts.conversationId || null,
          message: opts.message,
          locale: opts.locale || 'en',
          sourcePage: opts.sourcePage || location.pathname
        })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        if (!res.ok) {
          /* the function names its own state: rate_limit | budget | error */
          opts.onError({ kind: (res.data && res.data.kind) || 'error' });
          return;
        }
        opts.onOpen(res.data.conversationId);
        /* The endpoint returns the full reply; the widget renders token by
           token, so the visual stream is kept by chunking locally. */
        var parts = (res.data.reply || '').match(/\S+\s*/g) || [res.data.reply || ''];
        var i = 0;
        (function step() {
          if (i >= parts.length) { opts.onDone({ model: res.data.model }); return; }
          opts.onToken(parts[i++]);
          setTimeout(step, 24);
        })();
      }).catch(function () {
        opts.onError({ kind: 'error' });
      });
    },

    /* ------------------- retired mock path, verbatim ------------------- */
    _mockSend: function (opts) {
      var forced = window.ADVISOR_MOCK;
      var convId = opts.conversationId || 'mock-' + Math.random().toString(36).slice(2, 10);

      setTimeout(function () {
        if (forced === 'error' || forced === 'rate_limit' || forced === 'budget') {
          opts.onError({ kind: forced });
          return;
        }
        opts.onOpen(convId);

        var reply = AdvisorTransport._cannedReply(opts.message, opts.locale);
        var parts = reply.match(/\S+\s*/g) || [reply];
        var i = 0;
        (function step() {
          if (i >= parts.length) {
            opts.onDone({ model: 'mock' });
            return;
          }
          opts.onToken(parts[i++]);
          setTimeout(step, 38);
        })();
      }, 520);
    },

    /* Canned answers. These are DEMO TEXT, not salon content, and they never
       state a price the catalogue has not got: the gel figures below are the live
       Supabase values for Gel Polish, senior hand 100 and top hand 120. */
    _cannedReply: function (msg, locale) {
      var m = (msg || '').toLowerCase();
      if (locale === 'ja' || /[぀-ヿ一-龯]/.test(msg || '')) {
        return 'ご質問ありがとうございます。料金は担当するスタイリストによって変わります。'
             + '詳しいご案内と空き状況は /pages/book でご確認いただけます。';
      }
      if (/price|cost|how much|rm/.test(m)) {
        /* Named a departed stylist and quoted a Top-tier price until Sept 2026.
           Both were wrong in the same way: the roster had moved and the copy had
           not. It now names a TIER rather than a person, because a tier is a
           property of the menu and a person is not - a name here is a fact with
           an expiry date. The senior hand figure is the live Supabase value. */
        return 'Gel Polish depends on who performs it. With a Senior Stylist it '
             + 'is RM 100 for hands. The booking page confirms the exact price '
             + 'once you pick a stylist.';
      }
      if (/book|appointment|available|slot/.test(m)) {
        return 'Booking is on the booking page, which shows what is actually free '
             + 'and holds the slot for you. I cannot see the diary myself, so I '
             + 'would not want to promise a time.';
      }
      if (/fortunebrows|brow|eyebrow/.test(m)) {
        return 'Fortunebrows is YUKI’s own eyebrow method, combining feng shui '
             + 'with brow design. There is a page about it at /pages/fortunebrows.';
      }
      return 'I can help with prices, what each treatment involves, and how to book. '
           + 'What would you like to know?';
    }
  };
  window.AdvisorTransport = AdvisorTransport;

  /* ======================================================================
     WIDGET. Everything below is transport-agnostic.
     ====================================================================== */
  var launcher = document.getElementById('adv-launcher');
  var panel    = document.getElementById('adv-panel');
  if (!launcher || !panel) return;

  var views = {
    home:     document.getElementById('adv-view-home'),
    messages: document.getElementById('adv-view-messages'),
    help:     document.getElementById('adv-view-help'),
    visit:    document.getElementById('adv-view-visit')
  };
  var tabs       = [].slice.call(document.querySelectorAll('[data-adv-tab]'));
  var tabDot     = document.getElementById('adv-tab-dot');
  var launchDot  = document.getElementById('adv-launcher-dot');
  var scroller   = document.getElementById('adv-scroll');
  var transcript = document.getElementById('adv-transcript');
  var pills      = document.getElementById('adv-pills');
  var errBox     = document.getElementById('adv-error');
  var limitBox   = document.getElementById('adv-limit');
  var form       = document.getElementById('adv-form');
  var input      = document.getElementById('adv-input');
  var sendBtn    = document.getElementById('adv-send');
  var statusEl   = document.getElementById('adv-status');
  var helpList   = document.getElementById('adv-help-list');
  var helpBack   = document.getElementById('adv-help-back');
  var answerEl   = document.getElementById('adv-answer');
  var homeTopics = document.getElementById('adv-home-topics');

  var busy = false;
  var current = 'home';

  /* ---------------------------------------------- sticky book bar clearance */
  /* The bar is full width at bottom:0 and only visible at <=768px once
     scrollY > innerHeight. Rather than duplicating that threshold, watch the
     bar's own class and raise the launcher by the bar's MEASURED height. A copied
     threshold desynchronises the day someone changes it. */
  (function stickyClearance() {
    var bar = document.getElementById('sticky-book-bar');
    if (!bar) return;
    function sync() {
      var shown = bar.classList.contains('is-visible') &&
                  getComputedStyle(bar).display !== 'none';
      if (shown) {
        var h = Math.round(bar.getBoundingClientRect().height);
        launcher.style.setProperty('--adv-raise', (h + 14) + 'px');
      }
      launcher.classList.toggle('adv-launcher--raised', shown);
    }
    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  })();

  /* --------------------------------------- and the same clearance for the PANEL */
  /* SEPARATE BLOCK BY DESIGN. The clearance code above is preserved byte-identical
     from the first build, so this does not edit it: it MIRRORS what that block
     already worked out, by watching the launcher it writes to.

     Why it is needed. Measured on /pages/service-nail at 390x844 with the bar up:
     the panel's bottom was 824 and the bar's top 790, so the open panel's last 34px
     sat over the bar. The panel outranks it (1010 against 900) so nothing was
     hidden, but the tab bar and the bar's Book button ended up at nearly the same y,
     with the bar exposed in the 8px and 23px margins either side of the panel. That
     is a mis-tap waiting to happen, and it looks careless.

     A copied constant is wrong here for the same reason it is wrong above, so the
     value is read from the launcher rather than restated. */
  (function panelClearance() {
    function mirror() {
      var raised = launcher.classList.contains('adv-launcher--raised');
      panel.style.setProperty('--adv-raise', launcher.style.getPropertyValue('--adv-raise') || '62px');
      panel.classList.toggle('adv-panel--raised', raised);
    }
    new MutationObserver(mirror).observe(launcher, { attributes: true, attributeFilter: ['class', 'style'] });
    window.addEventListener('resize', mirror, { passive: true });
    mirror();
  })();

  /* ------------------------------------------------------------ tab routing */
  function show(name) {
    if (!views[name]) return;
    Object.keys(views).forEach(function (k) { views[k].hidden = (k !== name); });
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-adv-tab') === name;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    current = name;
    /* opening Messages clears the unread indicator */
    if (name === 'messages') { tabDot.hidden = true; launchDot.hidden = true; }
    if (name === 'help') resetHelp();
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () { show(t.getAttribute('data-adv-tab')); });
  });
  panel.addEventListener('click', function (e) {
    var go = e.target.closest('[data-adv-goto]');
    if (go) {
      var dest = go.getAttribute('data-adv-goto');
      show(dest);
      /* Focus the composer only when the destination is the composer. The
         Messages header's back button also carries data-adv-goto, and focusing a
         hidden textarea from it would be wrong. */
      if (dest === 'messages' && input) input.focus();
      return;
    }
    if (e.target.closest('[data-adv-close]')) close();
  });

  /* ------------------------------------------------------------ open, close */
  function open() {
    panel.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    /* If a reply landed while the panel was shut, the launcher is wearing an
       unread dot. Opening onto Home would then show a badge that leads nowhere,
       so go where the unread thing actually is. Otherwise Home is the default. */
    if (!launchDot.hidden) show('messages');
    launchDot.hidden = true;
  }
  function close() {
    panel.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    launcher.focus();                       /* focus returns to the launcher */
  }
  launcher.addEventListener('click', function () { panel.hidden ? open() : close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) { e.preventDefault(); close(); }
  });

  /* ------------------------------------------------------- HELP and topics */
  function topicButton(t, showGroup) {
    var li = document.createElement('li');
    var b  = document.createElement('button');
    b.type = 'button';
    b.className = 'adv-topic';
    b.setAttribute('data-topic', t.id);
    var s = document.createElement('span');
    s.className = 'adv-topic__t';
    if (t.lang === 'ja') s.setAttribute('lang', 'ja');
    s.textContent = t.q;
    b.appendChild(s);
    if (showGroup) {
      var g = document.createElement('span');
      g.className = 'adv-topic__g';
      g.textContent = t.group;
      b.appendChild(g);
    }
    var c = document.createElement('span');
    c.className = 'adv-topic__c';
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
    b.appendChild(c);
    li.appendChild(b);
    return li;
  }
  function renderTopics(el, list, showGroup) {
    el.innerHTML = '';
    /* A search that matches nothing must SAY so. Rendering an empty list is
       indistinguishable from the list failing to render, and it leaves the
       customer with no next step. */
    if (!list.length) {
      var li = document.createElement('li');
      li.className = 'adv-empty';
      li.innerHTML = '<span>No help topic matches that.</span>'
                   + '<button type="button" class="adv-empty__go" data-adv-goto="messages">Ask the advisor instead</button>';
      el.appendChild(li);
      return;
    }
    /* Help groups under eyebrow headers instead of a per-row tag. The shape this
       produces is honest: one long HIFU group and three short practical ones,
       because HIFU is the only category with sourced FAQ content. The topics array
       is already ordered group-contiguous, so a simple change detector suffices. */
    var lastGroup = null;
    list.forEach(function (t) {
      if (showGroup && t.group !== lastGroup) {
        lastGroup = t.group;
        var h = document.createElement('li');
        h.className = 'adv-topics__g';
        var dot = document.createElement('span');
        dot.className = 'adv-eyebrow__dot';
        dot.setAttribute('aria-hidden', 'true');
        h.appendChild(dot);
        h.appendChild(document.createTextNode(t.group));
        el.appendChild(h);
      }
      el.appendChild(topicButton(t, false));
    });
  }
  function openTopic(id) {
    var t = HELP.filter(function (x) { return x.id === id; })[0];
    if (!t) return;
    show('help');
    helpList.hidden = true;
    answerEl.hidden = false;
    helpBack.hidden = false;
    answerEl.innerHTML = '';
    var q = document.createElement('h3');
    q.className = 'adv-answer__q';
    if (t.lang === 'ja') q.setAttribute('lang', 'ja');
    q.textContent = t.q;
    var a = document.createElement('p');
    a.className = 'adv-answer__a';
    if (t.lang === 'ja') a.setAttribute('lang', 'ja');
    a.textContent = t.a;
    answerEl.appendChild(q);
    answerEl.appendChild(a);
    /* Where the answer came from, so a reader can tell salon source text from UI
       copy. The nine Japanese ones are the salon's own words, unedited. */
    if (t.src === 'service-facials') {
      var n = document.createElement('p');
      n.className = 'adv-answer__note';
      n.textContent = 'From the salon\u2019s own HIFU page, unedited.';
      answerEl.appendChild(n);
    }
  }
  function resetHelp() {
    helpList.hidden = false;
    answerEl.hidden = true;
    helpBack.hidden = true;
  }
  helpBack.addEventListener('click', resetHelp);
  [helpList, homeTopics].forEach(function (el) {
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-topic]');
      if (b) openTopic(b.getAttribute('data-topic'));
    });
  });
  function filterTopics(q) {
    q = (q || '').trim().toLowerCase();
    if (!q) return HELP;
    return HELP.filter(function (t) {
      return (t.q + ' ' + t.a + ' ' + t.group).toLowerCase().indexOf(q) !== -1;
    });
  }
  var hs = document.getElementById('adv-help-search');
  if (hs) hs.addEventListener('input', function () {
    resetHelp();
    renderTopics(helpList, filterTopics(hs.value), true);
  });
  var homeSearch = document.getElementById('adv-home-search');
  if (homeSearch) homeSearch.addEventListener('input', function () {
    var q = homeSearch.value.trim();
    renderTopics(homeTopics, q ? filterTopics(q).slice(0, 6) : HELP.slice(9), false);
  });
  /* Home shows the four practical topics; Help shows all thirteen. Home leading
     with nine Japanese HIFU questions would misrepresent what the salon does. */
  renderTopics(homeTopics, HELP.slice(9), false);
  renderTopics(helpList, HELP, true);

  /* ------------------------------------------------------------- transcript */
  var CJK = /[\u3040-\u30ff\u4e00-\u9fff]/;
  /* A STREAMED bubble is created EMPTY, so testing its text at creation always
     says "not Japanese" and the reply renders in Instrument Sans instead of Noto
     Sans JP. Tag it again once the text has actually arrived. */
  function tagLang(p) {
    if (CJK.test(p.textContent || '')) p.setAttribute('lang', 'ja');
    else p.removeAttribute('lang');
  }
  function bubble(role, text) {
    var wrap = document.createElement('div');
    wrap.className = 'adv-msg adv-msg--' + (role === 'user' ? 'user' : 'bot');
    var p = document.createElement('p');
    p.className = 'adv-msg__b';
    p.textContent = text || '';
    tagLang(p);
    wrap.appendChild(p);
    transcript.appendChild(wrap);
    toBottom();
    return { p: p, wrap: wrap };
  }
  function attribution(wrap) {
    var a = document.createElement('div');
    a.className = 'adv-attr';
    a.innerHTML = '<img src="' + (CFG.markUrl || '') + '" alt="" width="15" height="14">'
                + '<span>Yuki Advisor \u00b7 AI Assistant \u00b7 Just now</span>';
    if (!CFG.markUrl) a.querySelector('img').remove();
    wrap.appendChild(a);
  }
  function typing() {
    var w = document.createElement('div');
    w.className = 'adv-msg adv-msg--bot';
    w.innerHTML = '<span class="adv-typing" aria-hidden="true"><span></span><span></span><span></span></span>';
    transcript.appendChild(w);
    toBottom();
    return w;
  }
  function toBottom() { if (scroller) scroller.scrollTop = scroller.scrollHeight; }

  /* Own-domain paths in bot text become tappable links. WHITELIST: only
     site-relative /pages/... paths are ever linked, so the bot cannot be
     induced to render an external link. Text nodes only; nothing is parsed
     as HTML. */
  var LINK_RE = /\/pages\/[a-z0-9\-]+(?:\?[A-Za-z0-9=&\-_%]*)?/g;
  /* The server composes locale-agnostic paths; the locale prefix is applied
     here at render so a tapped link stays in the guest's language. Display
     text keeps the bare path. */
  var LINK_ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  function linkify(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue || '';
      if (!LINK_RE.test(text)) { LINK_RE.lastIndex = 0; return; }
      LINK_RE.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var last = 0, m;
      while ((m = LINK_RE.exec(text))) {
        frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var a = document.createElement('a');
        a.href = LINK_ROOT + m[0];           /* relative: own domain only */
        a.textContent = m[0];
        a.className = 'adv-msg-link';
        frag.appendChild(a);
        last = m.index + m[0].length;
      }
      frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }
  function hideNotices() { errBox.hidden = true; limitBox.hidden = true; }

  /* ------------------------------------------------------------------ send */
  function ask(text) {
    if (busy || !text.trim()) return;
    busy = true;
    hideNotices();
    if (pills) pills.hidden = true;
    sendBtn.disabled = true;
    input.value = '';
    input.style.height = '';
    if (statusEl) statusEl.textContent = 'Thinking';

    bubble('user', text);
    var ind = typing();
    var target = null, caret = null, wrap = null;

    AdvisorTransport.send({
      /* localStorage, not sessionStorage: the conversation id survives the
         visit, so a returning customer continues their thread (go-live). */
      conversationId: localStorage.getItem(SKEY) || null,
      message: text,
      locale: CFG.locale || 'en',
      sourcePage: CFG.sourcePage || location.pathname,

      onOpen: function (id) {
        if (id) { try { localStorage.setItem(SKEY, id); } catch (e) {} }
      },
      onToken: function (chunk) {
        if (!target) {
          if (ind && ind.parentNode) ind.parentNode.removeChild(ind);
          var made = bubble('assistant', '');
          target = made.p; wrap = made.wrap;
          caret = document.createElement('span');
          caret.className = 'adv-caret';
          target.appendChild(caret);
        }
        caret.insertAdjacentText('beforebegin', chunk);
        toBottom();
      },
      onDone: function () {
        if (ind && ind.parentNode) ind.parentNode.removeChild(ind);
        if (caret && caret.parentNode) caret.parentNode.removeChild(caret);
        if (target) tagLang(target);        /* the text exists only now */
        if (target) linkify(target);        /* own-domain paths become tappable */
        if (wrap) attribution(wrap);
        if (statusEl) statusEl.textContent = 'Ready';
        busy = false;
        syncSend();
        /* unread indicator only when the reply landed while Messages was not open */
        if (current !== 'messages') { tabDot.hidden = false; }
        if (panel.hidden) { launchDot.hidden = false; }
        toBottom();
      },
      onError: function (info) {
        if (ind && ind.parentNode) ind.parentNode.removeChild(ind);
        if (caret && caret.parentNode) caret.parentNode.removeChild(caret);
        /* budget exhaustion shows the limit notice on purpose: to a customer both
           mean "ask the salon directly", and a salon assistant naming a spend cap
           would read oddly. */
        var box = (info && (info.kind === 'rate_limit' || info.kind === 'budget')) ? limitBox : errBox;
        box.hidden = false;
        if (statusEl) statusEl.textContent = 'Ready';
        busy = false;
        syncSend();
        toBottom();
      }
    });
  }

  /* send is inactive until there is text */
  function syncSend() { sendBtn.disabled = busy || !input.value.trim(); }
  input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
    syncSend();
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); ask(input.value); }
  });
  if (pills) pills.addEventListener('click', function (e) {
    var b = e.target.closest('.adv-pill');
    if (b) { show('messages'); ask(b.getAttribute('data-seed') || b.textContent.trim()); }
  });
  syncSend();

  /* ------------------------------------------------------------ ROSTER ----
     WHO WORKS HERE, fetched rather than hardcoded.

     The markup ships EMPTY and hidden. Everything below only ever ADDS names,
     so every failure mode - offline, 403, malformed JSON, an empty roster -
     leaves the widget showing no roster at all. That is the deliberate choice:
     the bug being fixed here is a confidently wrong roster outliving the
     people in it, and a blank line cannot do that.

     /apps/account/roster is the Shopify app proxy, so Shopify signs the request
     on its way through and the Worker reads `working_staff`. Root-relative and
     locale-free on purpose: the proxy subpath is not translated, and prefixing
     it with the locale would 404 on /ja and /zh. */
  (function roster() {
    var strip = document.getElementById('adv-faces');
    var line  = document.getElementById('adv-who');
    var small = document.getElementById('adv-faces-sm');
    var mapEl = document.getElementById('adv-photos');
    if (!strip && !line && !small) return;

    var photos = {};
    try { photos = JSON.parse((mapEl && mapEl.textContent) || '{}'); } catch (e) { photos = {}; }
    var placeholder = photos._placeholder || '';

    function avatar(name, size) {
      var img = document.createElement('img');
      var src = photos[name];
      img.src = src || placeholder;
      /* No portrait yet: the house monogram, the same placeholder the About
         page uses, on a soft ground so it reads as a face slot and not as a
         broken image. Square crops of everyone are on the client list. */
      if (!src) img.className = 'adv-face--pending';
      img.width = size; img.height = size;
      img.loading = 'lazy';
      img.alt = '';
      return img;
    }

    function sentence(names) {
      if (names.length === 1) return names[0] + ' is here to help';
      /* "are in today" was the old wording and it is not recoverable from this
         data: business_hours leaves a blank cell meaning "not set" rather than
         "not working", so a per-day claim would be a guess dressed as a fact.
         Naming the team is true every day the salon is open. */
      return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1]
           + ' are here to help';
    }

    fetch('/apps/account/roster', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var staff = (d && d.staff) || [];
        var names = staff.map(function (s) { return s && s.name; }).filter(Boolean);
        if (!names.length) return;

        if (strip) {
          names.forEach(function (n) { strip.appendChild(avatar(n, 44)); });
          strip.hidden = false;
        }
        if (small) {
          /* The Ask card is a decorative cluster, not a directory: three is the
             most that fits at 28px without the overlap turning to mush. */
          names.slice(0, 3).forEach(function (n) { small.appendChild(avatar(n, 28)); });
        }
        if (line) { line.textContent = sentence(names); line.hidden = false; }
      })
      .catch(function () { /* stays hidden - see the note above */ });
  })();

  show('home');                                /* Home is the default view */
})();
